.root,
.root > span {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}
.root {
  flex-wrap: wrap;
  gap: var(--space-2);
}
.root img {
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
}
.root strong {
  font-weight: inherit;
}
